import { useEffect } from 'react';

import { trackEvent } from '@/Infrastructure/Utils/analytics/braze/brazeClient';

export const useBrazeCheckoutStarted = () => {
  useEffect(() => {
    trackEvent('checkout_started');
  }, []);
};
